import { forwardRef, type InputHTMLAttributes } from "react";

import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { twMerge } from "@/utils/twMerge";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  onCrossClick?: () => void;
  icon?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { icon, onCrossClick, ...props }: Props,
  ref,
) {
  const t = useTranslations("doc");

  return (
    <div className="relative flex flex-1 h-10">
      {icon && (
        <div className="absolute top-0 left-0 flex items-center justify-center w-8 h-full pointer-events-none">
          {icon}
        </div>
      )}
      <input
        {...props}
        ref={ref}
        placeholder={props.placeholder || t("input.placeholder")}
        className={twMerge(
          "rounded-8 w-full h-full px-2.5 pr-12 text-ellipsis text-sm bg-white shadow-input dark:shadow-input-inverted dark:bg-black",
          !!icon && "pl-8",
        )}
      />
      {props.value && onCrossClick && (
        <button
          onClick={onCrossClick}
          type="button"
          className="absolute top-0 right-0 flex items-center justify-center w-12 h-full"
          aria-label={t("input.cancel")}
        >
          <Icon name="Cross" />
        </button>
      )}
    </div>
  );
});
